export default __webpack_public_path__ + "static/media/halonasoft-logotype-d.c31f5b9a.svg";